import Transformer from './Transformer';

export default class CustomerTransformer extends Transformer {
  static fetch(customer) {
    const tranformedCustomer = {
      customerHash: customer.customerHash,
    };
    if (customer.customerData) {
      Object.assign(tranformedCustomer, {
        name: customer.customerData.customerName,
        firstname: customer.customerData.customerFirstName,
        salutation: customer.customerData.title,
        dateOfBirth: customer.customerData.dateOfBirth,
        customerNo: customer.customerData.customerNumber,
        customerNoType: customer.customerData.customerNumberType,
        vbkz: customer.customerData.vbkz,
      });
    }
    return tranformedCustomer;
  }
}
